import React, { useEffect, useState, useRef } from "react";
import checkImg from "../../assets/images/check-2.svg";
import { useUserContext } from "libs/context/UserContext";
import { Offcanvas } from "bootstrap";
import CandidateTrackApplication from "pages/CandidateTrackApplication/candidate-track-application";
import { toast } from "react-toastify";
import { updateFetchDetails } from "model/Partners";
import { formatDataBeforeSend } from "helpers/GeneralHelper";
import * as Yup from "yup";
import { candidateUpdateExperienceData, handleDeleteExperience } from "model/CandidateDetailsModel";
import Swal from "sweetalert2";
import { Spinner } from "reactstrap";
import NotInterestedCommonButton from "pages/NotInterestedCommonButton/not-interested-common-button";


const CandidateExperience = () => {
    const inputFields = {
        CompanyName: "",
        Position: "",
        Duration: "",
        JobType: "",
    };
    const inputFieldsDelete = {

    };

    const formatOptions = [];
    const [fields, setFields] = useState(inputFields);
    const formatOptionsDelete = [];
    const [fieldsDelete, setFieldsDelete] = useState(inputFieldsDelete);
    const [errors, setErrors] = useState({});
    const { candidateDetailsData, fetchCandidateDetailsDataForUpdate, loadingDetailsForUpdate } = useUserContext();
    const initialExperiences = candidateDetailsData?.WorkExperiencesEdit || [];

    const [experienceEdit, setExperienceEdit] = useState(false);
    const [experiences, setExperiences] = useState(initialExperiences);
    const [editingIndex, setEditingIndex] = useState(null);
    const [editedData, setEditedData] = useState(null);

    const offcanvasRef = useRef(null);
    const offcanvasInstanceRef = useRef(null);

    const InterestedOrNot = localStorage?.getItem("InterestedOrNot")
    const [InterestedValue, setInterested] = useState(false);

    //   useEffect(() => {
    //     if (offcanvasRef.current) {
    //       offcanvasInstanceRef.current = new Offcanvas(offcanvasRef.current);
    //     }
    //   }, []);
    useEffect(() => {
        if (offcanvasRef.current) {
            offcanvasInstanceRef.current = new Offcanvas(offcanvasRef.current, {
                backdrop: true,   // keeps backdrop
                scroll: true,     // allow body scroll
                keyboard: true    // close on ESC
            });
        }
    }, []);

    const openOffcanvas = () => {
        offcanvasInstanceRef.current?.show();
    };

    const handleAdd = () => {
        setFields(inputFields);
        setErrors({});
        setEditingIndex(experiences.length);
        setExperienceEdit(true);
    };

    //   const handleDelete = async (index, item) => {
    //     // const updated = experiences.filter((_, i) => i !== index);
    //     // setExperiences(updated);

    //     try {
    //         // await validationSchema.validate(fields, { abortEarly: false });
    //         // const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
    //         let response = await handleDeleteExperience({id: item?.id});

    //         if (response?.status) {
    //           toast.success(response?.message);
    //           fetchCandidateDetailsDataForUpdate();
    //         } else {
    //           toast.error("Failed to update experience");
    //         }
    //       } catch (err) {
    //         toast.error(err);
    //       }
    //   };


    const handleDelete = async (index, item) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This action will delete the experience permanently!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const formData = formatDataBeforeSend(fieldsDelete, inputFieldsDelete, formatOptionsDelete);
                    const workExperienceId = item?.WorkExperienceId || item?._WorkExperienceId;
                    if (workExperienceId) {
                        formData?.append("WorkExperienceId", workExperienceId)
                    }
                    let response = await handleDeleteExperience(formData);

                    if (response?.IsSuccess) {
                        Swal.fire("Deleted!", response?.Message || "Experience deleted successfully.", "success");
                        fetchCandidateDetailsDataForUpdate();
                    } else {
                        Swal.fire("Error!", "Failed to update experience", "error");
                    }
                } catch (err) {
                    Swal.fire("Error!", err?.message || "Something went wrong", "error");
                }
            }
        });
    };


    const cancelForm = () => {
        setExperienceEdit(false);
        setEditingIndex(null);
        setFields(inputFields);
        setErrors({});
        setExperiences(initialExperiences); // reset
    };

    const validationSchema = Yup.object().shape({
        CompanyName: Yup.string().required("Company name is required"),
        Position: Yup.string().required("Position is required"),
        Duration: Yup.string().required("Duration is required"),
        JobType: Yup.string().required("Job Type is required"),
    });

    const handleChange = async (e) => {
        const { name, value } = e.target;
        setFields({ ...fields, [name]: value });

        try {
            await Yup.reach(validationSchema, name).validate(value);
            setErrors((prev) => ({ ...prev, [name]: "" }));
        } catch (err) {
            setErrors((prev) => ({ ...prev, [name]: err.message }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await validationSchema.validate(fields, { abortEarly: false });
            const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
            const workExperienceId = editedData?.WorkExperienceId || editedData?._WorkExperienceId;
            if (workExperienceId) {
                formData?.append("WorkExperienceId", workExperienceId);
            }
            let response = await candidateUpdateExperienceData(formData);

            if (response?.IsSuccess) {
                toast.success(response?.Message);
                fetchCandidateDetailsDataForUpdate();
                setExperienceEdit(false);
                setEditingIndex(null);
            } else {
                toast.error("Failed to update experience");
            }
        } catch (err) {
            if (err.inner) {
                const fieldErrors = {};
                err.inner.forEach((e) => {
                    fieldErrors[e.path] = e.message;
                });
                setErrors(fieldErrors);
            } else {
                toast.error(err?.message || "Something went wrong");
            }
        }
    };

    const handleEdit = (item, index) => {
        setEditedData(item)
        setFields(item);
        setErrors({});
        setEditingIndex(index);
        setExperienceEdit(true);
    };

    useEffect(() => {
        setInterested(false)
        if (InterestedOrNot == 'Not-Interested') {
            setInterested(false)
        }
        else if (InterestedOrNot == 'Interested') {
            setInterested(true)
        }
    }, [InterestedOrNot]);

    return (
        <>
            {/* <div className="app-status text-end"> */}
            {/* <button
          className="btn btn-primary-2 w-100-percent"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#application_status"
          aria-controls="application_status"
          onClick={openOffcanvas}
        >
          Track Application
        </button> */}
            {/* {(candidateDetailsData?.Interested) && */}
                <div className="active-mob-device d-xl-none">
                    <button className="btn btn-primary-2 btn-callback-mob"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#application_status"
                        aria-controls="application_status"
                        onClick={openOffcanvas}
                    >
                        Track Application
                    </button>

                </div>
            {/* // } */}
            {/* </div> */}
            {(loadingDetailsForUpdate) ? (
                <div className="text-center py-5">
                    <Spinner color="primary" /> Loading...
                </div>
            ) :
                (
                    <div
                        className="tab-pane fade show active mt-4"
                        id="pills-Experience"
                        role="tabpanel"
                        aria-labelledby="pills-Experience-tab"
                    >
                        {/* View mode */}
                        {!experienceEdit && (
                            <div className="row gap-3">
                                <div className="col-12">
                                    <div className="table-responsive py-2 px-1">
                                        <table
                                            className="table experience-table table-borderless"
                                            id="experience-table-desktop"
                                        >
                                            <thead className="table-light">
                                                <tr>
                                                    <th scope="col">Company</th>
                                                    <th scope="col">Position</th>
                                                    <th scope="col">Duration</th>
                                                    <th scope="col">Type</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {initialExperiences?.map((exp, index) => (
                                                    <tr key={index}>
                                                        <td>{exp.CompanyName}</td>
                                                        <td>{exp.Position}</td>
                                                        <td>{exp.Duration}</td>
                                                        <td>
                                                            <span className="badge rounded-md bg-light px-4 py-2 text-primary-color">
                                                                {exp.JobType}
                                                            </span>
                                                        </td>
                                                        {exp?.CompanyName &&
                                                            <td align="middle">
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    className="bg-lightblue px-2 rounded text-white me-2"
                                                                    onClick={() => handleEdit(exp, index)}
                                                                >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="16"
                                                                        height="16"
                                                                        fill="currentColor"
                                                                        className="bi bi-pencil-square"
                                                                        viewBox="0 0 16 16"
                                                                    >
                                                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                                        <path
                                                                            fillRule="evenodd"
                                                                            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                                                        />
                                                                    </svg>
                                                                </a>
                                                                <a
                                                                    href="javascript:void(0)"
                                                                    className="bg-lightblue px-2 rounded text-white me-2"
                                                                    onClick={() => handleDelete(index, exp)}
                                                                >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="16"
                                                                        height="16"
                                                                        fill="currentColor"
                                                                        className="bi bi-trash3"
                                                                        viewBox="0 0 16 16"
                                                                    >
                                                                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                                                    </svg>
                                                                </a>
                                                            </td>
                                                        }
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        {/* Mobile card view */}
                                        {initialExperiences?.map((exp, index) => (
                                            <div className="card mb-2" id="experience-table-mob" key={index}>
                                                {exp?.CompanyName ?
                                                    <div className="card-body position-relative">
                                                        <ul>
                                                            <li>
                                                                <strong className="text-dark">Company :</strong> {exp.CompanyName}
                                                            </li>
                                                            <li>
                                                                <strong className="text-dark">Position :</strong> {exp.Position}
                                                            </li>
                                                            <li>
                                                                <strong className="text-dark">Duration :</strong> {exp.Duration}
                                                            </li>
                                                            <li>
                                                                <strong className="text-dark">Type :</strong>{" "}
                                                                <span className="badge rounded-md bg-secondary-subtle px-2 py-2 text-dark ms-2">
                                                                    {exp.JobType}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                        <div className="edit-icons d-flex gap-2">
                                                            <a
                                                                href="javascript:void(0)"
                                                                className="bg-lightblue px-2 rounded text-white"
                                                                onClick={() => handleEdit(exp, index)}
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    fill="currentColor"
                                                                    className="bi bi-pencil-square"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                                    <path
                                                                        fillRule="evenodd"
                                                                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                                                    />
                                                                </svg>
                                                            </a>
                                                            <a
                                                                href="javascript:void(0)"
                                                                className="bg-lightblue px-2 rounded text-white"
                                                                onClick={() => handleDelete(index, exp)}
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="16"
                                                                    height="16"
                                                                    fill="currentColor"
                                                                    className="bi bi-trash3"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                                                </svg>
                                                            </a>
                                                        </div>
                                                    </div> :
                                                    <div className="card-body position-relative">
                                                        No Data Found
                                                    </div>
                                                }
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="d-flex justify-content-end align-items-start">
                                        <button className="btn btn-primary-2" onClick={handleAdd}>
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Edit mode */}
                        {experienceEdit && (
                            <form className="row g-3" onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-12 mt-4">
                                        <div className="table-responsive py-2 px-1">
                                            <table className="table experience-table table-borderless" id="experience-table-desktop">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th scope="col">Company</th>
                                                        <th scope="col">Position</th>
                                                        <th scope="col">Duration</th>
                                                        <th scope="col">Type</th>
                                                        {/* <th></th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Company name"
                                                                value={fields?.CompanyName}
                                                                onChange={handleChange}
                                                                name="CompanyName"
                                                            />
                                                            {errors.CompanyName && (
                                                                <div className="text-danger">{errors.CompanyName}</div>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Position"
                                                                value={fields?.Position}
                                                                onChange={handleChange}
                                                                name="Position"
                                                            />
                                                            {errors.Position && (
                                                                <div className="text-danger">{errors.Position}</div>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Duration"
                                                                value={fields?.Duration}
                                                                onChange={handleChange}
                                                                name="Duration"
                                                            />
                                                            {errors.Duration && (
                                                                <div className="text-danger">{errors.Duration}</div>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <select
                                                                className="form-select"
                                                                value={fields?.JobType}
                                                                name="JobType"
                                                                onChange={handleChange}
                                                            >
                                                                <option value="">Select Job Type</option>
                                                                <option value="driver">Driver</option>
                                                                <option value="non-driver">Non-Driver</option>
                                                            </select>
                                                            {errors.JobType && (
                                                                <div className="text-danger">{errors.JobType}</div>
                                                            )}
                                                        </td>
                                                        {/* <td>
                          <button className="btn btn-link" type="submit">
                            <img src={checkImg} alt="check" />
                          </button>
                        </td> */}
                                                    </tr>
                                                </tbody>
                                            </table>

                                            {/* Mobile form */}
                                            <div className="card" id="experience-table-mob">
                                                <div className="card-body p-0">
                                                    <div className="row g-3">
                                                        <div className="col-12">
                                                            <div className="form-floating">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Company name"
                                                                    value={fields?.CompanyName}
                                                                    onChange={handleChange}
                                                                    name="CompanyName"
                                                                />
                                                                <label>Company</label>
                                                                {errors.CompanyName && (
                                                                    <div className="text-danger">{errors.CompanyName}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="form-floating">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Position"
                                                                    value={fields?.Position}
                                                                    onChange={handleChange}
                                                                    name="Position"
                                                                />
                                                                <label>Position</label>
                                                                {errors.Position && (
                                                                    <div className="text-danger">{errors.Position}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="form-floating">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Duration"
                                                                    value={fields?.Duration}
                                                                    onChange={handleChange}
                                                                    name="Duration"
                                                                />
                                                                <label>Duration</label>
                                                                {errors.Duration && (
                                                                    <div className="text-danger">{errors.Duration}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="form-floating">
                                                                <select
                                                                    className="form-select"
                                                                    value={fields?.JobType}
                                                                    name="JobType"
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="">Select Job Type</option>
                                                                    <option value="driver">Driver</option>
                                                                    <option value="non-driver">Non-Driver</option>
                                                                </select>
                                                                <label>Type</label>
                                                                {errors.JobType && (
                                                                    <div className="text-danger">{errors.JobType}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="d-flex justify-content-end mt-4">
                                            <div className="col-auto me-2">
                                                <button className="btn btn-primary-1" onClick={cancelForm}>
                                                    CANCEL
                                                </button>
                                            </div>
                                            <div className="col-auto">
                                                <button className="btn btn-primary-2 bg-dark" type="submit">
                                                    SAVE
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                        <hr />
                        {/* <div className="row justify-content-center">
          <div className="col-auto">
            <button className="btn btn-primary-1">Not Interested Anymore</button>
          </div>
        </div> */}
                        {/* <NotInterestedCommonButton /> */}

                        <CandidateTrackApplication
                            offcanvasRef={offcanvasRef}
                            offcanvasInstanceRef={offcanvasInstanceRef}
                        />
                    </div>
                )}
        </>
    );
};

export default CandidateExperience;
